import { ReactNode } from 'react';
import { Flex, Text } from '@backstage/ui';

export type StatusTone = 'success' | 'warning' | 'danger' | 'neutral';

const TONE_COLORS: Record<StatusTone, string> = {
  success: 'var(--bui-fg-success)',
  warning: 'var(--bui-fg-warning)',
  danger: 'var(--bui-fg-danger)',
  neutral: 'var(--bui-fg-secondary)',
};

export const StatusDot = ({ tone }: { tone: StatusTone }) => (
  <span
    aria-hidden
    style={{
      width: 8,
      height: 8,
      borderRadius: '50%',
      background: TONE_COLORS[tone],
      display: 'inline-block',
      flexShrink: 0,
    }}
  />
);

export const StatusLabel = ({
  tone,
  children,
}: {
  tone: StatusTone;
  children: ReactNode;
}) => (
  <Flex align="center" gap="2">
    <StatusDot tone={tone} />
    <Text variant="body-medium">{children}</Text>
  </Flex>
);
